import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import convoStore from '../convo-store'
import setConvoQuery from './set-convo-query'

export default async function removeSearchTag(context: BareActionContext<ConvoState, RootState>, tag: string)
{
  const form = convoStore.state.convoSearchForm
  if (form.tags.indexOf(tag) >= 0) {
    form.tags.splice(form.tags.indexOf(tag), 1)
  }
  setConvoQuery(context)

  return
}
